<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="!permissaoInserir">
            <div style="text-align: center">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="permissaoInserir && !exibirSpinnerPrincipal">
            <form #form="ngForm" name="form" novalidate (ngSubmit)="salvar()">
                <div class="formgroup">
                    <div class="p-fluid p-formgrid grid">
                        <div *ngIf="messagemVisivel" class="field col-12 md:col-12">
                            <p-messages
                                [(value)]="messages"
                                [enableService]="false"
                                [closable]="true"
                            ></p-messages>
                        </div>

                        <div class="field col-12 md:col-5">
                            <label htmlFor="descricao">Descrição</label>
                            <input
                                oninput="this.value = this.value.toUpperCase();"
                                type="text"
                                pInputText
                                placeholder="Descrição do produto"
                                name="descricao"
                                [(ngModel)]="itemProduto.descricao"
                                #descricao="ngModel"
                                required
                            />
                            <div
                                *ngIf="descricao.hasError('required') && descricao.touched"
                                class="alerta"
                            >
                                <span>Campo obrigatório!</span>
                            </div>
                        </div>

                        <div class="field col-12 md:col-3">
                            <label htmlFor="fabricante">Fabricante</label>
                            <p-dropdown
                                [options]="fabricantes"
                                optionLabel="descricao"
                                [filter]="true"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                name="fabricante"
                                [(ngModel)]="itemProduto.fabricante"
                                #fabricante="ngModel"
                                [required]="true"
                            ></p-dropdown>
                            <div *ngIf="fabricante.touched && !fabricante.value" class="alerta">
                                <span>Por favor, selecione um valor.</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="subgrupo">Grupo</label>
                            <p-dropdown
                                [options]="subgrupos"
                                optionLabel="label"
                                [filter]="true"
                                optionValue="value"
                                emptyFilterMessage="Nenhum registro"
                                placeholder="Selecione"
                                name="subgrupo"
                                [(ngModel)]="itemProduto.subgrupo"
                                #subgrupo="ngModel"
                                [required]=true
                            ></p-dropdown>
                            <div *ngIf="subgrupo.touched && !subgrupo.value" class="alerta">
                                <span>Por favor, selecione um valor.</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorCompra">Valor Compra</label>
                            <p-inputNumber
                                name="valorCompra"
                                mode="currency"
                                inputId="currency-brazil"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="false"
                                [(ngModel)]="itemProduto.valorCompra"
                                #valorCompra="ngModel"
                                (onBlur)="calcularValorSugerido()"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="lucro">Lucro</label>
                            <p-inputNumber
                                suffix="%"
                                name="lucro"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                [allowEmpty]="false"
                                [(ngModel)]="itemProduto.lucro"
                                #lucro="ngModel"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="valorVenda">Valor Venda</label>
                            <div class="flex flex-row">
                                <p-inputNumber
                                    name="valorVenda"
                                    mode="currency"
                                    inputId="currency-brazil"
                                    currency="BRL"
                                    locale="pt-BR"
                                    [allowEmpty]="false"
                                    [(ngModel)]="itemProduto.valorVenda"
                                    #valorVenda="ngModel"
                                ></p-inputNumber>
                                <button
                                    pButton
                                    pRipple
                                    pTooltip="Calcular precificação"
                                    type="button"
                                    icon="pi pi-percentage"
                                    class="p-button-success w-4rem ml-1"
                                    (click)="abrirDialogValorSugerido()"
                                ></button>
                            </div>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="comissaoVenda">Comissão de Venda</label>
                            <p-inputNumber
                                suffix="%"
                                name="comissaoVenda"
                                [max]="100"
                                [minFractionDigits]="2"
                                [maxFractionDigits]="2"
                                [allowEmpty]="false"
                                [(ngModel)]="itemProduto.comissaoVenda"
                                #comissaoVenda="ngModel"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-4">
                            <label htmlFor="codigo">Código</label>
                            <input
                                type="text"
                                pInputText
                                name="codigo"
                                [(ngModel)]="itemProduto.codigo"
                                #codigo="ngModel"
                                (blur)="verificarCodigoExistente(codigo.value)"
                                (input)="codigoExistente = false"
                                oninput="this.value = this.value.toUpperCase();"
                                required
                            />
                            <div
                                class="alerta"
                                *ngIf="codigo.invalid && (codigo.dirty || codigo.touched)"
                            >
                                <ng-container *ngIf="codigo.errors?.['required']">
                                    O código é obrigatório.
                                </ng-container>
                            </div>
                            <div class="alerta" *ngIf="codigoExistente">
                                <span>Código já cadastrado!</span>
                            </div>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="controlaEstoque">Controla Estoque</label>
                            <br />
                            <p-inputSwitch
                                name="controlaEstoque"
                                [(ngModel)]="itemProduto.controlaEstoque"
                                #controlaEstoque="ngModel"
                            ></p-inputSwitch>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="estoqueMinimo">Estoque Mínimo</label>
                            <p-inputNumber
                                name="estoqueMinimo"
                                [(ngModel)]="itemProduto.estoqueMinimo"
                                #estoqueMinimo="ngModel"
                                mode="decimal"
                                [allowEmpty]="false"
                                [useGrouping]="false"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="estoqueMaximo">Estoque Máximo</label>
                            <p-inputNumber
                                name="estoqueMaximo"
                                [(ngModel)]="itemProduto.estoqueMaximo"
                                #estoqueMaximo="ngModel"
                                mode="decimal"
                                [allowEmpty]="false"
                                [useGrouping]="false"
                            ></p-inputNumber>
                        </div>
                        <div class="field col-12 md:col-2">
                            <label htmlFor="quantidadeUnidadeMedida">Qtd. UN de Medida</label>
                            <p-inputNumber
                                name="quantidadeUnidadeMedida"
                                mode="decimal"
                                [allowEmpty]="false"
                                [useGrouping]="false"
                                [(ngModel)]="itemProduto.quantidadeUnidadeMedida"
                                #quantidadeUnidadeMedida="ngModel"
                            ></p-inputNumber>
                        </div>

                        <div class="field col-12 md:col-2">
                            <label htmlFor="descricaoUnidadeMedida">Desc. UN de Medida</label>
                            <p-dropdown
                                [options]="unidadesMedidas"
                                [filter]="true"
                                optionLabel="label"
                                optionValue="value"
                                emptyFilterMessage="Nenhum registro"
                                name="descricaoUnidadeMedida"
                                [(ngModel)]="itemProduto.descricaoUnidadeMedida"
                                #descricaoUnidadeMedida="ngModel"
                            ></p-dropdown>
                        </div>
                        <div class="field col-12 md:col-1">
                            <label for="tributacao">Tributável</label>
                            <br />
                            <p-inputSwitch
                                name="tributacao"
                                #tributacao="ngModel"
                                [(ngModel)]="itemProduto.tributacao"
                            ></p-inputSwitch>
                        </div>
                    </div>

                    <div class="p-fluid p-formgrid grid justify-content-between">
                        <div class="col-12 md:col-4">
                            <button
                                type="submit"
                                pButton
                                [icon]="
                                    progressoRequisicao ? 'pi pi-spin pi-spinner' : 'pi pi-check'
                                "
                                [label]="progressoRequisicao ? 'Salvando...' : 'Salvar'"
                                class="p-button-outlined p-button-success sm:w-9rem"
                                [disabled]="progressoRequisicao || !form.valid || codigoExistente"
                            ></button>
                        </div>
                        <div class="col-12 md:col-4 flex justify-content-end">
                            <button
                                type="button"
                                pButton
                                icon="pi pi-arrow-left"
                                label="Voltar"
                                class="p-button-outlined sm:w-9rem"
                                routerLink="/apps/item-produto"
                            ></button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<p-dialog
    [(visible)]="exibirDialogValorSugerido"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
    [style]="{ width: '35vw' }"
    header="Sugestão de Preço"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    class="p-fluid"
>
    <ng-template pTemplate="content">
        <div class="flex justify-content-center" *ngIf="loadingSpinnerDialog">
            <p-progressSpinner></p-progressSpinner>
        </div>
        <div class="formgrid grid" *ngIf="!loadingSpinnerDialog && itemProduto">
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Valor Compra</label>
                <label class="block">
                    {{ itemProduto.valorCompra | currency: "BRL" }}
                </label>
            </div>

            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Lucro</label>
                <label class="block">
                    {{ (itemProduto.lucro ?? 0) / 100 | percent: "1.2-2" }} |
                    {{
                        ((itemProduto.lucro ?? 0) * (itemProduto.valorCompra ?? 0)) / 100
                            | currency: "BRL"
                    }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Comissão</label>
                <label class="block">
                    {{
                        itemProduto.comissaoVenda
                            ? (itemProduto.comissaoVenda / 100 | percent: "1.2-2")
                            : "0,00%"
                    }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Custo Fixo</label>
                <label class="block">
                    {{ custoMedio.custoFixo / 100 | percent: "1.2-2" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Custo Tributário</label>
                <label class="block">
                    {{ custoMedio.imposto / 100 | percent: "1.2-2" }}
                </label>
            </div>
            <div class="field col-12 sm:col-6">
                <label class="font-semibold text-lg">Valor Venda</label>
                <label class="block">
                    {{ itemProduto.valorVenda | currency: "BRL" }}
                </label>
            </div>

            <div style="width: 100%">
                <p-divider></p-divider>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Valor Sugerido</label>
                <label class="block">
                    {{ valorSugerido | currency: "BRL" }}
                </label>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Novo Valor</label>
                <p-inputNumber
                    name="novoValor"
                    ngModel
                    mode="currency"
                    currency="BRL"
                    locale="pt-BR"
                    [allowEmpty]="true"
                    [required]="true"
                    (onInput)="calcularLucroObtido($event.value)"
                    [(ngModel)]="novoValor"
                ></p-inputNumber>
            </div>
            <div class="field col-12 sm:col-4">
                <label class="font-semibold text-lg">Lucro Obtido</label>
                <label class="block">
                    <span
                        class="product-badge bg-green-600 admihair-text-white"
                        *ngIf="valorLucroObtido >= 0"
                    >
                        {{ valorLucroObtido | currency: "BRL" }}
                    </span>
                    <span
                        class="product-badge bg-red-600 admihair-text-white"
                        *ngIf="valorLucroObtido < 0"
                    >
                        {{ valorLucroObtido | currency: "BRL" }}
                    </span>
                </label>
            </div>
            <!-- <div class="field col-12 sm:col-6">
                            <label class="font-semibold text-lg">Lucro Desejado</label>
                            <p-inputNumber
                                name="valorLucroDesejado"
                                ngModel
                                mode="currency"
                                currency="BRL"
                                locale="pt-BR"
                                [allowEmpty]="true"
                                [required]="true"
                                [(ngModel)]="valorLucroDesejado"
                                (ngModelChange)="calcularValorSugerido()"
                            ></p-inputNumber>
                        </div> -->
        </div>
        <div class="flex justify-content-start mt-3" *ngIf="!loadingSpinnerDialog">
            <button
                type="button"
                pButton
                pRipple
                label="Confirmar"
                icon="pi pi-check"
                class="p-button-outlined w-full md:w-12rem"
                [disabled]="novoValor <= 0"
                (click)="confirmarNovoValor()"
            ></button>
        </div>
    </ng-template>
</p-dialog>
